import { render } from "./InviteClient.vue?vue&type=template&id=4d1f5c04&scoped=true"
import script from "./InviteClient.vue?vue&type=script&lang=js"
export * from "./InviteClient.vue?vue&type=script&lang=js"

import "./InviteClient.vue?vue&type=style&index=0&id=4d1f5c04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1f5c04"]])

export default __exports__